export const SERVICE_OPTIONS = [
  "Tax Services",
  "Bookkeeping",
  "Payroll",
  "Financial Advisory",
  "Business Advisory",
  "Accounts Outsourcing",
  "Internal Audit",
  "Fractional CFO",
  "Financial Modeling",
  "Financial Systems Development",
  "Legal Advisory",
  "1099 Contractor Compliance",
];

export const INDUSTRY_OPTIONS = [
  "Manufacturing",
  "Construction",
  "Healthcare",
  "Retail & E-commerce",
  "Technology",
  "Logistics & Supply Chain",
  "Professional Services",
  "Hospitality",
  "Real Estate",
  "Education",
  "Non-Profit",
  "Financial Services",
  "Other"
];
